module.exports = __webpack_public_path__ + "docusign-icon.png?4d0ce1360a659faef014f3bbedd60951";